import React from "react";
import { ContentItem } from "@/types/content";
import { ContentCard } from "@/components/content/ContentCard";
import { Clock, UploadCloud, Link2, Youtube } from "lucide-react";
interface HistoryPageProps {
  items: ContentItem[];
  isLoading?: boolean;
}
export const HistoryPage: React.FC<HistoryPageProps> = ({ items, isLoading = false }) => {
  const hasItems = items && items.length > 0;
  return (
    <div className="flex flex-col min-h-[calc(100vh-72px)]">
      {/* Header */}
      <header className="mb-6">
        <h1 className="text-2xl md:text-3xl font-medium">History</h1>
        


      </header>

      {/* Loading */}
      {isLoading &&
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
          {Array.from({
          length: 8
        }).map((_, i) =>
        <div key={i} className="h-64 rounded-2xl border bg-muted/40 animate-pulse" />
        )}
        </div>
      }

      {/* Populated State */}
      {!isLoading && hasItems &&
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
          {items.map((item) =>
        <ContentCard key={item.id} item={item} href={`/content/${item.id}`} />
        )}
        </div>
      }

      {/* Empty state */}
      {!isLoading && !hasItems &&
      <div className="flex items-center justify-center h-full py-16">
          <div className="text-center max-w-xl px-4">
            <h2 className="text-xl mb-2 font-medium">Upload files, links, or YouTube videos to view content.</h2>
            <p className="text-sm text-muted-foreground mb-6">
              Learn at your own pace and track your progress. Your history is a collection of all the content you've added.

            </p>

            













          </div>
        </div>}
    </div>);

};